import React from "react";
import { Link } from "react-router-dom";
import "../../css/SchoolLevels.css";

const SchoolLevels = () => {
  const schoolWings = [
    {
      id: 1,
      title: "Pre Primary",
      description: "A joyful start to learning with strong early foundations.",
      image: "/images/a.jpeg",
      path: "/pre-primary",
    },
    {
      id: 2,
      title: "Primary School",
      description:
        "Concept-building, curiosity, and confidence in core subjects.",
      image: "/images/primary.jpg",
      path: "/primary-school",
    },
    {
      id: 3,
      title: "Secondary School",
      description:
        "Deeper academic engagement with skill development and self-discovery.",
      image: "/images/o.jpeg",
      path: "/secondary-school",
    },
    {
      id: 4,
      title: "High School",
      description: "Focused preparation for board success and future careers.",
      image: "/images/high.jpg",
      path: "/high-school",
    },
  ];

  return (
    <>
      <section className="school-levels-section">
        <div className="levels-container">
          {}
          <div className="levels-header-row">
            <h2 className="levels-main-title">School Levels</h2>

            <div className="levels-dropdown">
              <Link to="/school-level" className="levels-view-all-btn">
                SCHOOL LEVELS <span>▼</span>
              </Link>

              <div className="levels-dropdown-menu">
                {schoolWings.map((wing) => (
                  <Link key={wing.id} to={wing.path}>
                    {wing.title}
                  </Link>
                ))}
              </div>
            </div>
          </div>

          {}
          <div className="levels-cards-grid">
            {schoolWings.map((wing) => (
              <Link key={wing.id} to={wing.path} className="wing-level-card">
                <div className="wing-image-container">
                  <img
                    src={wing.image}
                    alt={wing.title}
                    className="wing-display-img"
                  />
                </div>

                <div className="wing-text-details">
                  <h3 className="wing-title-heading">{wing.title}</h3>

                  <p className="wing-description-para">{wing.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default SchoolLevels;
